import React, { useCallback } from 'react';

import useSWR from 'swr';

import byteSize from 'byte-size';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

import { fetchModelVersionStorageSize } from '../../../../utils/api_functions/removeModelVersions';

export const useModelVersionStorageSize = (versions) => {
  const {
    data,
    error,
    isLoading,
  } = useSWR(['admin-model-versions-storage-size', versions], fetchModelVersionStorageSize, {
    refreshInterval: 3000,
    loadingTimeout: 1000,
  });

  return {
    data,
    error,
    isLoading,
  }
}

// TODO - Show different message if it's the last orchestration instance vs if there are multiple
export const ModelVersionRemovalModal = ({
  error = null,
  versions = {},
  onVersionsRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const { data } = useModelVersionStorageSize(versions);
  const storage = data?.bytes || 0;
  const storageData = byteSize(storage);
  const storageLabel = `${storageData.value} ${storageData.unit}`;

  const onConfirm = useCallback(() => {
    onVersionsRemoved(versions);
  }, [onVersionsRemoved, versions])

  return (
    <ConfirmationDialog
      title="Delete Selected Version(s)"
      confirmButtonText="Delete"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="delete-model-versions-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1 flex flex-col">
        <Label>
          The selected model version(s) will be deleted from Wallaroo. Are you sure?
        </Label>
        <Label className="mt-2">
          Storage to be freed: { storageLabel }
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the model. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default ModelVersionRemovalModal;
